import $ from 'jquery';
import BasketService from '../service/BasketService';
import Cookie from '../util/Cookie';

const updateProductQuantity = (domObject, quantityDelta) => {
    const mainObjectDom = domObject.parents('.catalog-item-to-basket');
    const currentCount = mainObjectDom.attr('data-quantity');

    let quantity = (+currentCount) + (+quantityDelta);
    if (quantity === 0) {
        quantity = 1;
    }

    mainObjectDom.attr('data-quantity', quantity);
    mainObjectDom.find('.catalog-item-to-basket__quantity').text(quantity);
};

$('body').on('click', '.js-catalog-item-to-basket__button', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const productId = $(this).parents('.catalog-item-to-basket').attr('data-catalog-item-id');
    const productQuantity = $(this).parents('.catalog-item-to-basket').attr('data-quantity');

    BasketService.add(productId, productQuantity).then(({ count }) => {
        $('.header-cart__quantity').text(count).removeClass('hidden').addClass('header-cart__quantity--added');
        setTimeout(() => {
            $('.header-cart__quantity').removeClass('header-cart__quantity--added');
        }, 300);

        if (Cookie.get('back_to_basket') !== false) {
            window.location.href = '/basket';
        }

        $(this).parents('.catalog-item-to-basket').empty().append(
            '<a class="catalog-item-to-basket__to-basket" href="/basket">Go to basket</a>'
        ).addClass('catalog-item-to-basket--narrow');
    });
});

$('body').on('click', '.js-catalog-item-to-basket__minus', function (e) {
    e.preventDefault();
    e.stopPropagation();
    updateProductQuantity($(this), -1);
});

$('body').on('click', '.js-catalog-item-to-basket__plus', function (e) {
    e.preventDefault();
    e.stopPropagation();
    updateProductQuantity($(this), 1);
});
